// @flow
import * as React from 'react'
import FlexBox from 'ui/atoms/FlexBox'
import DateField from 'ui/molecules/DateField'
import { momentLocal } from 'utils/helpers'

type Props = {
  formErrorLabel: { [string]: string },
  formError: { [string]: string },
  dateOfBirth: ?string,
  validateDateOfBirth: (string) => void,
  setDob: (string) => void,
}

function SendResourceModalDOBField({
  formErrorLabel,
  formError,
  dateOfBirth,
  setDob,
  validateDateOfBirth,
}: Props): React.Node {
  const maxValidDate = React.useRef(momentLocal().format('MM-DD-YYYY')).current

  return (
    <FlexBox>
      <DateField
        semibold
        errorLabel={formErrorLabel?.dob}
        hasError={Boolean(formError?.dob)}
        label="Date of Birth"
        maxDate={maxValidDate}
        name="person_date_of_birth"
        onBlur={validateDateOfBirth}
        onChange={(value) => {
          if (!value) return
          const stringValue = value[1]
          setDob(stringValue)
          validateDateOfBirth(stringValue)
        }}
        placeholder="Date of birth"
        value={dateOfBirth}
      />
    </FlexBox>
  )
}

export default SendResourceModalDOBField
